import Motion from '../models/motion'
import MotionState from '../enums/motion-state'
// import PropType from '../enums/prop-type'

const motionIncludes = [
  'proposer',
  'seconder',
  'session',
  'speakers',
  'speakers.delegate',
  'parent'
]

export default class Api {
  constructor (axios, uri) {
    this.axios = axios
    this.uri = uri
    this.authToken = null
    this.username = null
  }

  setCredentials (credentials) {
    this.authToken = credentials.token
    this.username = credentials.username
  }

  async login (credentials) {
    const response = await this.axios.post(
      this.uri,
      credentials,
      {
        params: {
          r: 'auth/token'
        }
      }
    )
    return response.data
  }

  async getSessions () {
    const response = await this.get('event-session-api/index')
    return response.body.data.map((d) => d.model)
    // return response.body.data.map((e) => Session.fromJson(e.model))
  }

  async getMotions (extra) {
    const response = await this.get(
      'motion-api/index',
      Object.assign({}, {
        expand: motionIncludes.join(',')
      }, extra)
    )
    return response.body.models.map((e) => Motion.fromJson(e))
  }

  async getDelegates () {
    const response = await this.get(
      'delegate-api/index'
    )
    return response.body.models
  }

  async createCard (card) {
    const response = await this.get(
      'delegate-motion-api/add',
      card
    )
    return response.body
  }

  async createCardPOST (card) {
    const response = await this.post(
      'delegate-motion-api/update',
      card,
      {
        delegate_id: card.delegate_id
      }
    )
    return response.body
  }

  async getMotion (id) {
    const response = await this.get(
      'motion-api/view',
      {
        id: id,
        expand: motionIncludes.join(',')
      }
    )
    return Motion.fromJson(response.body)
  }

  async getCurrentMotion () {
    const response = await this.get('current-motion-api/update')
    // eslint-disable-next-line
    if (response.data == []) {
      return null
    }
    if (!response.data.motion) {
      return null
    }
    return Motion.fromCurrentJson(response.body)
  }

  async getSpeakers (motion) {
    return this.get('motion-delegate-api/index', {motion_id: motion.id})
  }

  async showSpeakers (motion) {
    return this.get('screen-manager-api/show-speakers', {})
  }

  async hideSpeakers (motion) {
    return this.get('screen-manager-api/hide-speakers', {})
  }

  async getScreen () {
    const response = await this.get('on-screen-api/index')
    return response.body
  }

  async setScreen (screen) {
    console.log(screen)
    const response = await this.get(
      'screen-api/set',
      screen
    )
    return response.body
  }
  async changeCurrentMotionState (state, reason = null) {
    return this.get(
      'current-motion-api/change-state',
      {
        state: state,
        reason: reason
      }
    )
  }

  async passCurrentMotion (reason = null) {
    return this.changeCurrentMotionState(MotionState.PASSED, reason)
  }

  async failCurrentMotion (reason = null) {
    return this.changeCurrentMotionState(MotionState.FAILED, reason)
  }

  async holdCurrentMotion (reason = null) {
    return this.changeCurrentMotionState(MotionState.HOLD, reason)
  }

  async speakerSpeak (speaker) {
    return this.get('current-motion-api/speak', { id: speaker.id })
  }

  async speakerFinish (speaker) {
    return this.get('current-motion-api/finish', { id: speaker.id })
  }

  async speakerWithdraw (speaker) {
    console.log('withdrawing, in API')
    return this.get('current-motion-api/withdraw', { id: speaker.id })
  }

  async propSpeak (type) {
    return this.get('current-motion-api/prop-speak', {
      who: type
    })
  }

  async propFinish (type) {
    return this.get('current-motion-api/prop-finish', {
      who: type
    })
  }

  async uploadScreenshot (data) {
    return this.post('screenshot/create', data)
  }

  async get (path, params = {}) {
    // eslint-disable-next-line no-return-await
    return this.axios.get(
      this.uri,
      {
        params: Object.assign({}, {
          r: path,
          token: this.authToken,
          _username: this.username
        }, params)
      }
    )
  }

  async post (path, data, params = {}) {
    // eslint-disable-next-line no-return-await
    return this.axios.post(
      this.uri,
      data,
      {
        params: Object.assign({}, {
          r: path,
          token: this.authToken,
          _username: this.username
        }, params)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/api.js